// import { Product } from 'components'

const quantityControl = {
  el: {
    controls: document.querySelectorAll('.qty-control'),
    qtyBubble: document.querySelector<HTMLElement>('.top__qty'),
  },
  init() {
    if (this.el.controls) {
      Array.prototype.forEach.call(this.el.controls, i => {
        const items = (<NodeList>i.querySelectorAll('.qty-control__item'))
        const input = (<HTMLInputElement>i.querySelector('.qty-control__input'))
        const minus = (<HTMLButtonElement>i.querySelector('[data-decrement]'))
        const plus = (<HTMLButtonElement>i.querySelector('[data-increment]'))

        // const form = (<HTMLFormElement>i.querySelector('.cart__qty-form'))

        Array.prototype.forEach.call(items, j => {
          j.addEventListener('click', (e: Event & { target: HTMLButtonElement }) => {
            if (e.target.hasAttribute('data-increment')) {
              minus.removeAttribute('disabled')
              minus.classList.remove('button--disabled')

              if (parseInt(input.value) < parseInt(input.max)) {
                this.increment(parseInt(input.value), input)
              }

              if (parseInt(input.value) >= parseInt(input.max)) {
                plus.setAttribute('disabled', 'true')
                plus.classList.add('button--disabled')
              }
            }

            if (e.target.hasAttribute('data-decrement')) {
              if (parseInt(input.value) > 1) {
                plus.removeAttribute('disabled')
                plus.classList.remove('button--disabled')
                this.decrement(parseInt(input.value), input)
              }

              if (parseInt(input.value) <= 1) {
                setTimeout(() => {
                  minus.setAttribute('disabled', 'true')
                  minus.classList.add('button--disabled')
                }, 0)
              }
            }
          })
        })
      })
    }
  },

  increment(value, target) {
    target.value = (value + 1).toString()
  },
  decrement(value, target) {
    target.value = (value - 1).toString()
  },
}

export default quantityControl
